module.exports = __webpack_public_path__ + "static/media/mail.6cb010b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mail.svg
// module id = 1099
// module chunks = 0